/* SMAEL — interruptor Lua/Sol (modo escuro/claro).
   CLARO (dia) é o padrão para quem entra na loja; ESCURO (noite) é a loja de antes. A escolha do visitante fica em localStorage 'smael-tema'
   ('escuro' | 'claro'). O atributo data-smael-tema no <html> é definido ANTES de pintar (script inline no <head> de layout/theme.liquid);
   aqui só o clique, a acessibilidade e a sincronização entre abas. */
(function () {
  var KEY = 'smael-tema';

  function atual() { return document.documentElement.getAttribute('data-smael-tema') === 'escuro' ? 'escuro' : 'claro'; }

  function sincronizar() {
    var escuro = atual() === 'escuro';
    document.querySelectorAll('[data-smael-tema-toggle]').forEach(function (b) {
      b.setAttribute('aria-checked', escuro ? 'false' : 'true');                    // ligado = modo claro (sol)
      b.setAttribute('aria-label', escuro ? 'Switch to light mode' : 'Switch to dark mode');
      b.setAttribute('title', escuro ? 'Light mode' : 'Dark mode');
    });
  }

  function definir(t) {
    document.documentElement.setAttribute('data-smael-tema', t);
    try { localStorage.setItem(KEY, t); } catch (e) {}
    sincronizar();
    document.dispatchEvent(new CustomEvent('smael:tema', { detail: { tema: t } }));
  }

  window.SmaelTema = { definir: definir, atual: atual };   // usado pelos botões Dia/Noite do menu do celular

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-smael-tema-toggle]');
    if (!b) return;
    e.preventDefault();
    definir(atual() === 'escuro' ? 'claro' : 'escuro');
  });

  window.addEventListener('storage', function (e) {            // outra aba mudou o tema
    if (e.key === KEY && (e.newValue === 'claro' || e.newValue === 'escuro')) {
      document.documentElement.setAttribute('data-smael-tema', e.newValue); sincronizar();
    }
  });
  window.addEventListener('pageshow', sincronizar);
  document.addEventListener('shopify:section:load', sincronizar);   // editor de temas
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sincronizar); else sincronizar();
})();
